import { createApp } from 'vue';
import App from './App.vue';
import { router } from './router';


const app = createApp(App);
import APIS from './api/api-config.js';
app.config.globalProperties.$apis = APIS.apiList


import request from './utils/request.js';
app.config.globalProperties.$http = request
app.use(router);
app.mount('#app');


app.config.globalProperties.OPENAPP = function () {
	debugger
  if (/android/i.test(navigator.userAgent)) {
    //alert("This is Android'browser.");//这是Android平台下浏览器
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      alert("微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"); //这是微信平台下浏览器

      return
    }else{
			if (navigator.userAgent.match(/android/i)) {
			  window.location.href = "nowbook://nowbook"; //android app协议
			  //谷歌链接展示不可以用
			  var href = 'https://play.google.com/store/apps/details?id=com.suep.nowbook';
			  window.setTimeout(function () {
			    window.location.href = href;
			  }, 2000);
			}
		}
  }
  else if (/(iPhone|iPad|iPod|iOS)/i.test(navigator.userAgent)) {
    //alert("This is iOS'browser.");//这是iOS平台下浏览器
    if (/MicroMessenger/i.test(navigator.userAgent)) {
      alert(
        "微信内置浏览器不支持打开本地应用,请点击右上角使用本地浏览器打开"
      ); //这是微信平台下浏览器
      return
    }else{
			if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
			  window.location.href = "nowbook://"; //ios app协议
			  window.setTimeout(function () {
			    window.location.href = "itms-apps://itunes.apple.com/cn/app/id1446373183";
			  }, 2000);
			}
		}
  }else{
		//pc
		window.location.href = "https://test-parentnet.cctechhk.com/";
	}





}



